import { render, staticRenderFns } from "./TrainingsList.vue?vue&type=template&id=389db6c2&"
import script from "./TrainingsList.vue?vue&type=script&lang=js&"
export * from "./TrainingsList.vue?vue&type=script&lang=js&"
import style0 from "./TrainingsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports